// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ba662e5a64e4{overflow:hidden !important}", "",{"version":3,"sources":["webpack://./src/styles/scroll.scss"],"names":[],"mappings":"AAAA,cACI,0BAAA","sourcesContent":[".no-scroll{\n    overflow: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-scroll": "ba662e5a64e4"
};
export default ___CSS_LOADER_EXPORT___;
